import R from 'ramda';
import * as steps from './steps';
import { getCompleted, hasErrors } from './stepReducerUtil';
import { getProject, getOrganization } from 'application/applicationReducer';
import { isActiveStep } from 'submission/submissionReducer';

export const getStep = R.curry((step, state) =>
  R.view(R.lensProp(step), state),
);

export const isStepCompleted = R.curry((step, state) =>
  getCompleted(getStep(step, state)),
);

export const getIncompleteSteps = state =>
  R.filter(R.complement(isStepCompleted(R.__, state)), steps.list);

export const getNextIncompleteStep = R.pipe(getIncompleteSteps, R.head);

export const doesStepHaveErrors = R.curry((step, state) =>
  hasErrors(getStep(step, state)),
);

export const getApplication = R.view(R.lensProp('application'));

export const getProjectKey = R.pipe(
  getApplication,
  getProject,
  R.prop('projectKey'),
);

export const getProjectId = R.pipe(
  getApplication,
  getProject,
  R.prop('projectId'),
);

export const getOrganizationAlias = R.pipe(
  getApplication,
  getOrganization,
  R.prop('alias'),
);

export const getRedirectUri = R.pipe(
  getApplication,
  getProject,
  R.prop('redirectUri'),
);

const getSubmission = R.view(R.lensProp('submission'));

export const isStepActive = R.curry((step, state) =>
  R.pipe(getSubmission, isActiveStep(step))(state),
);



// WEBPACK FOOTER //
// ./src/common/selectors.js